// model
import AccAccountingSeatConceptModel from '@/models/Accounting/AccAccountingSeatConcept'

// service
export default class AccAccountingSeatConcept {

  /**
   * 
   */
  static create(accAccountingSeatConcept) {
    return accAccountingSeatConcept.save()
  }

  /**
   * 
   */
  static model() {
    return AccAccountingSeatConceptModel
  }

  /**
   * 
   */
  static remove(accAccountingSeatConcept) {
    return accAccountingSeatConcept.delete()
  }

  /**
   * 
   */
  static toCreate() {
    return this.model().from({
      code: '',
      concept: '',
    })
  }

  /**
   * 
   */
  static toList() {
    return this.model()
  }

  /**
   * 
   */
  static update(accAccountingSeatConcept) {
    return accAccountingSeatConcept.save()
  }
}